import { render, staticRenderFns } from "./CreateReplacementCost.vue?vue&type=template&id=7b52dc4e"
import script from "./CreateReplacementCost.vue?vue&type=script&lang=js"
export * from "./CreateReplacementCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports